import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../styles/AuthModal.css";
import Cookies from "js-cookie";
import { useAuth } from "../context/AuthContext";




import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

const AuthModal = ({ onClose, isLoginType, onLoginSuccess }) => {
    const [isLogin, setIsLogin] = useState(isLoginType); // true - Вход, false - Регистрация
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [promoCode, setPromoCode] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { showNotification } = useAuth();
    const { t, i18n } = useTranslation();



    const handleAuth = async (event) => {

        event.preventDefault();

        if (isLogin) {
            handleAuthLogin();
        }
        else {
            handleAuthRegister();
        }

    };


    const handleAuthRegister = async () => {

        let ref = new URLSearchParams(window.location.search).get("ref") || Cookies.get("ref_id");
        let cpa = new URLSearchParams(window.location.search).get("cpa") || Cookies.get("cpa_id");
        if (ref) {
            console.log(`🔗 [AUTH_MODAL] Используется реферальная ссылка для регистрации: ref_id=${ref}`);
        }
        if (cpa) {
            console.log(`🔗 [AUTH_MODAL] Используется CPA ссылка для регистрации: cpa_id=${cpa}`);
        }
        if (Cookies.get("ref_id")) {
            Cookies.remove("ref_id");
            console.log(`🗑️ [AUTH_MODAL] Реферальная ссылка удалена из cookies после использования`);
        }
        if (Cookies.get("cpa_id")) {
            Cookies.remove("cpa_id");
            console.log(`🗑️ [AUTH_MODAL] CPA ссылка удалена из cookies после использования`);
        }
        const endpoint = "/api/register";
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const response = await fetch(`${API_URL}${endpoint}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password, ref, cpa, timezone, promoCode })
        });

        const data = await response.json();
        if (data.success) {
            handleAuthLogin();

        } else {
            alert(data.message);
        }
    };


    // Функция для определения, запущено ли приложение в мобильном WebView
    const isMobileApp = () => {
        // Проверяем User-Agent на наличие признаков мобильного приложения
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        // Проверяем специфичные для WebView строки
        const isWebView = (
            // Android WebView
            /wv/.test(userAgent) ||
            // Проверка на Android WebView через специфичные признаки
            (userAgent.includes('Android') && userAgent.includes('Version/') && !userAgent.includes('Chrome/')) ||
            // iOS WebView (UIWebView или WKWebView)
            (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent)) ||
            // Дополнительная проверка для React Native WebView
            userAgent.includes('ReactNativeWebView')
        );

        // Дополнительная проверка через window объект (для React Native)
        const hasReactNativeWebView = typeof window.ReactNativeWebView !== 'undefined';

        console.log('🔍 [AUTH] Проверка мобильного приложения:', {
            userAgent,
            isWebView,
            hasReactNativeWebView,
            result: isWebView || hasReactNativeWebView
        });

        return isWebView || hasReactNativeWebView;
    };

    const handleAuthLogin = async () => {
        setIsLoading(true);
        try {
            // Проверяем, входит ли пользователь с мобильного приложения
            const isFromMobileApp = isMobileApp();

            const response = await fetch(`${API_URL}/api/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    email, 
                    password,
                    isFromMobileApp  // Передаем флаг на сервер
                }),
                credentials: 'include'  // Обязательно для сохранения cookies
            });

            const data = await response.json();
            console.log("Ответ сервера при логине:", data);

            if (data.success) {
                // Если начислен бонус за APK - показываем специальное уведомление
                if (data.apkBonusAwarded) {
                    showNotification("🎉 Вход выполнен! Вы получили +30 фриспинов за вход через мобильное приложение!", "success");
                } else {
                    showNotification("Вход выполнен успешно", "success");
                }
                onLoginSuccess();
                onClose();
            } else {
                showNotification(data.message || "Ошибка входа", "error");
            }
        } catch (error) {
            console.error("Ошибка при входе:", error);
            showNotification("Ошибка при входе в систему", "error");
        } finally {
            setIsLoading(false);
        }
    };




    const handleForgotPassword = async () => {
        if (!email) {
            showNotification("Введите email для восстановления пароля.", "error");
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${API_URL}/api/forgot-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            showNotification(data.message, data.success ? "success" : "error");
        } catch (error) {
            showNotification("Произошла ошибка при отправке запроса", "error");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-overlay">
            <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
                <button className="profile-modal-close" onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
                <h3 className="profile-modal-title">{isLogin ? t("auth.login") : t("auth.register")}</h3>

                {/* <div className="auth-welcome">{t("entrance.welcome1")}</div> */}

                <div className="auth-tabs">
                    <button
                        className={isLogin ? "active lefttab" : "lefttab"}
                        onClick={() => setIsLogin(true)}
                    >
                        {t("auth.login")}
                    </button>
                    <button
                        className={!isLogin ? "active righttab" : "righttab"}
                        onClick={() => setIsLogin(false)}
                    >
                        {t("auth.register")}
                    </button>
                </div>
                <form className="auth-content" onSubmit={handleAuth}>
                    <div className="input-wrapper">
                        <input
                            type="text"
                            name="email"
                            placeholder={isLogin ? "Email или логин" : "Email"}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="username"
                            required
                        />
                    </div>

                    <div className="input-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            placeholder={t("auth.password")}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                        {isLogin && (
                            <button
                                type="button"
                                className="forgot-password-inline"
                                onClick={handleForgotPassword}
                                disabled={isLoading}
                            >
                                {isLoading ? t("Common.loading") : t("vhod.forgotShort")}
                            </button>
                        )}
                        <button
                            type="button"
                            className="toggle-password"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="currentColor" />
                                </svg>
                            ) : (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.79 17.5 12 17.5C8.21 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z" fill="currentColor" />
                                    <path d="M2 4L22 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            )}
                        </button>
                    </div>

                    {!isLogin && (
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="promoCode"
                                placeholder="Промокод (необязательно)"
                                value={promoCode}
                                onChange={(e) => setPromoCode(e.target.value)}
                                autoComplete="off"
                            />
                        </div>
                    )}

                    <button type="submit" className="btn-authmodal auth-submit">
                        {isLogin ? t("auth.login") : t("auth.register")}
                    </button>

                    {!isLogin && (
                        <div className="auth-agreement-hint">
                            {t('auth.agreementHint', 'Регистрируясь, вы соглашаетесь с правилами и условиями')}
                        </div>
                    )}
                </form>

                <div className="social-auth-divider">
                    <div className="divider-line"></div>
                    <span className="divider-text">Или войдите через</span>
                    <div className="divider-line"></div>
                </div>

                <div className="social-auth-buttons">
                    {/* <button className="social-auth-btn google-btn" type="button" onClick={() => { window.location.href = "/api/auth/google"; }}>
                        <img src="/assets/google-icon.svg" alt="Google" className="social-icon" />
                        <span>Google</span>
                    </button> */}
                    <button className="social-auth-btn telegram-btn telegram-btn-fullwidth" type="button" onClick={() => { window.location.href = "/telegram-login"; }}>
                        <img src="/assets/telegram-icon.svg" alt="Telegram" className="social-icon" />
                        <span>Telegram</span>
                    </button>
                </div>

                <div className="register-section">
                    {!isLogin ? (
                        <div className="register-section-row">
                            <span>{t("vhod.imeetacc")}</span>
                            <button
                                type="button"
                                className="register-link"
                                onClick={() => {
                                    setIsLogin(true);
                                }}
                            >
                                {t("vhod.loin")}
                            </button>
                        </div>
                    ) : (
                        <div className="register-section-row">
                            <span>{t("vhod.noacc")}</span>
                            <button
                                type="button"
                                className="register-link"
                                onClick={() => {
                                    setIsLogin(false);
                                }}
                            >
                                {t("vhod.reg")}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div >
    );

};

export default AuthModal;
